import { Guid, Nillable } from '@web/utils';
import { OrderStatus } from '../../shared/enums';
import { OrderNumber } from '../../shared/types';
import { RefundSummary } from '../../shared/models';

export class PublicOrderCollectionItem {
  public constructor(
    private readonly data: {
      canBeViewed: boolean;
      canShippingAddressBeUpdated: boolean;
      createdAt: Date;
      id: Guid;
      number: OrderNumber;
      status: OrderStatus;
      totalItems: number;
      totalPrice: number;
      refundSummary?: Nillable<RefundSummary>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): OrderNumber {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }

  public get totalItems(): number {
    return this.data.totalItems;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get refundSummary(): Nillable<RefundSummary> {
    return this.data.refundSummary;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canShippingAddressBeUpdated(): boolean {
    return this.data.canShippingAddressBeUpdated;
  }
}
